var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.evaluation
    ? _c(
        "div",
        [
          _c(
            "v-edit-dialog",
            {
              attrs: { large: "" },
              on: {
                save: _vm.save,
                open: _vm.syncEvaluationTags,
                cancel: _vm.syncEvaluationTags,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("v-combobox", {
                          attrs: {
                            items: _vm.allEvaluationTags,
                            "search-input": _vm.search,
                            "hide-no-data": !_vm.search,
                            "hide-details": true,
                            "hide-selected": "",
                            label: "Add Tags",
                            multiple: "",
                            chips: "",
                            "deletable-chips": "",
                          },
                          on: {
                            "update:searchInput": function ($event) {
                              _vm.search = $event
                            },
                            "update:search-input": function ($event) {
                              _vm.search = $event
                            },
                            change: _vm.onChange,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "no-data",
                                fn: function () {
                                  return [
                                    _c(
                                      "v-list-item",
                                      [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(' No results matching "'),
                                              _c("strong", [
                                                _vm._v(_vm._s(_vm.search)),
                                              ]),
                                              _vm._v('". Press '),
                                              _c("kbd", [_vm._v("tab")]),
                                              _vm._v(" to create a new one "),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            619152371
                          ),
                          model: {
                            value: _vm.tags,
                            callback: function ($$v) {
                              _vm.tags = $$v
                            },
                            expression: "tags",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                1995346236
              ),
            },
            [
              _vm._l(_vm.sortedEvaluationTags, function (tag) {
                return [
                  _vm.evaluation.editable
                    ? _c(
                        "v-chip",
                        {
                          key: tag.id + "_",
                          attrs: { small: "", close: "" },
                          on: {
                            "click:close": function ($event) {
                              return _vm.deleteTag(tag)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(tag.value) + " ")]
                      )
                    : _c(
                        "v-chip",
                        { key: tag.id + "_", attrs: { small: "" } },
                        [_vm._v(_vm._s(tag.value))]
                      ),
                ]
              }),
              _vm.evaluation.editable
                ? _c(
                    "v-icon",
                    {
                      staticClass: "ma-2",
                      attrs: { small: "", title: "Edit/Add Tag(s)" },
                    },
                    [_vm._v(" mdi-tag-plus ")]
                  )
                : _vm._e(),
            ],
            2
          ),
          _c("ActionDialog", {
            attrs: { type: "tag" },
            on: {
              cancel: function ($event) {
                _vm.deleteTagDialog = false
              },
              confirm: _vm.deleteTagConfirm,
            },
            model: {
              value: _vm.deleteTagDialog,
              callback: function ($$v) {
                _vm.deleteTagDialog = $$v
              },
              expression: "deleteTagDialog",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }